import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

export default function SectionHeader({ title, subtitle, to, linkLabel = 'View all' }) {
  return (
    <div className="mb-6 flex items-end justify-between gap-4">
      <div>
        <h2 className="text-2xl sm:text-3xl font-bold text-slate-900 dark:text-white">{title}</h2>
        {subtitle && <p className="mt-1 text-sm text-slate-500 dark:text-slate-400">{subtitle}</p>}
      </div>
      {to && (
        <Link
          to={to}
          className="hidden sm:inline-flex shrink-0 items-center gap-1 text-sm font-semibold text-primary-600 dark:text-primary-300 hover:gap-2 transition-all"
        >
          {linkLabel} <ArrowRight size={16} />
        </Link>
      )}
    </div>
  );
}
